<template>
    <div class="flex-row">
        <v-text-field
            class="rtls-text-field rtls-text-field--white product-offer-group__filter-bar"
            :placeholder="$tkey('filterAllRows')"
            autocomplete="off"
            append-icon="mdi-magnify"
            @input="callInputFunc"
        />
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    localizationKey: 'planning.promotionsMaintenance.offer.offerGroup',
    methods: {
        callInputFunc(event) {
            this.params.inputFunc(event.target.value);
        },
    },
});
</script>

<style lang="scss">
.product-offer-group__filter-bar {
    margin-left: 1rem;

    .v-field__field {
        width: 30rem;
    }
}
</style>
